import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretDown } from "@fortawesome/free-solid-svg-icons";
import Container from "react-bootstrap/Container";
import Dropdown from "react-bootstrap/Dropdown";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { Redirect, Route, Switch, withRouter } from "react-router-dom";

import "react-bootstrap-typeahead/css/Typeahead.css";
import "./App.css";

import { ChartArea } from "./_case_counts.js";
import { Treatments } from "./_treatments.js";
import { Vaccines } from "./_vaccines.js";

let PAGES = [
  ["casecounts", "Case Counts"],
  ["treatments", "Treatments"],
  ["vaccines", "Vaccines"],
];

let PAGE_TO_NAME = PAGES.reduce(function(obj, entry) {
  obj[entry[0]] = entry[1];
  return obj;
}, {});

class PageDropdown extends Component {
  constructor(props) {
    super(props);
    this.getDropdownItems = this.getDropdownItems.bind(this);
  }

  getDropdownItems(pageInfo) {
    let path = pageInfo[0];
    let pageName = pageInfo[1];
    return (
      <Dropdown.Item
        eventKey={path}
        key={path}
        href={"/" + path} 
        id={this.props.pageName === path ? "selected-page" : ""}
      >
        {pageName}
      </Dropdown.Item>
    );
  }

  render() {
    // The forwardRef is important!!
    // Dropdown needs access to the DOM node in order to position the Menu
    const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
      <span
        ref={ref}
        onClick={(e) => {
          e.preventDefault();
          onClick(e);
        }}
        id="page-title"
      >
        {children}
        &nbsp;
        <FontAwesomeIcon icon={faCaretDown} id="page-dropdown-icon" />
      </span>
    ));

    let dropdownItems = PAGES.map(this.getDropdownItems);

    return (
      <Dropdown id="page-dropdown" alignRight={true}>
        <Dropdown.Toggle as={CustomToggle} id="dropdown-custom-components">
          {PAGE_TO_NAME[this.props.pageName]}
        </Dropdown.Toggle>
        <Dropdown.Menu>{dropdownItems}</Dropdown.Menu>
      </Dropdown>
    );
  }
}

class App extends Component {
  constructor(props) {
    super(props);
    this.getPageName = this.getPageName.bind(this);
  }

  isPageSelected(page) {
    return this.getPageName() === page;
  }

  getPageName() {
    let tokens = this.props.location.pathname.split("/");
    if (tokens.length <= 1 || tokens[1] === "") {
      return "casecounts";
    } else {
      return tokens[1];
    }
  }

  render() {
    return (
      <Container fluid>
        <Navbar className="header navbar-dark">
          <Navbar.Brand href="/">COVID-19 Dashboard</Navbar.Brand>
          <Nav className="mr-auto">
            <PageDropdown pageName={this.getPageName()} />
          </Nav>
        </Navbar>
        <Switch>
          <Route exact path="/" component={ChartArea} />
          <Route exact path="/casecounts" component={ChartArea} />
          <Route exact path="/treatments" component={Treatments} />
          <Route exact path="/vaccines" component={Vaccines} />
          <Route path="/" render={() => <Redirect to="/" />} />
        </Switch>
      </Container>
    );
  }
}

export default withRouter((props) => <App {...props} />);



// WEBPACK FOOTER //
// ./src/App.js